// extracted by mini-css-extract-plugin
export var hidden = "_tz-0";